import { createAction, props } from '@ngrx/store';
import { ModuleArea, SiteModule } from '../site-modules';

export const moduleSelected = createAction('[COMPONENT: Header] (Module) Selected', props<{ module: SiteModule }>());

export const areaSelected = createAction('[COMPONENT: Header] (Area) Selected', props<{ module: SiteModule, area: ModuleArea }>());
